var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9854,
    cy: 23.4414,
    rx: 24.3878,
    ry: 23.4394,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5991 29.8542H29.5527V24.7276C29.5527 23.3212 28.9077 22.5366 27.7508 22.5366C26.4919 22.5366 25.7448 23.3542 25.7448 24.7276V29.8542H22.6984V20.332H25.7448V21.4028C25.7448 21.4028 26.7006 19.7898 28.8543 19.7898C31.0089 19.7898 32.5991 21.0543 32.5991 23.6707V29.8542ZM19.227 18.8091C18.1996 18.8091 17.3672 18.0019 17.3672 17.0065C17.3672 16.0118 18.1996 15.2046 19.227 15.2046C20.2536 15.2046 21.0861 16.0118 21.0861 17.0065C21.0868 18.0019 20.2536 18.8091 19.227 18.8091ZM17.3672 29.8542H21.1752V20.332H17.3672V29.8542Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedIn);
export default __webpack_public_path__ + "static/media/Footer-LinkedIn.005425b41c9544ee7834497a910d5e52.svg";
export { ForwardRef as ReactComponent };